// TODO: This file was created by bulk-decaffeinate.
// Sanity-check the conversion and remove this comment.
const CampaignConstants = Marty.createConstants([
  'CAMPAIGN_CREATE',
  'CAMPAIGN_UPDATE',
  'CAMPAIGN_FETCH',
  'CAMPAIGNS_FETCH',
  'CAMPAIGNS_FOR_END_USER_FETCH',
  'CAMPAIGN_RESULTS_FETCH',
  'CAMPAIGN_MEMBERS_FETCH',
  'CAMPAIGN_RESPONSES_FETCH',
  'SAVE_ANNOUNCEMENT_DRAFT',
  'SAVE_NPS_DRAFT',
  'CAMPAIGN_DELETE',
  'SEND_TEST_CAMPAIGN'
])

CampaignConstants.SELECTED_END_USER_IDS_FOR_CAMPAIGN_KEY = 'selectedEndUserIdsForCampaign'

export default CampaignConstants



// WEBPACK FOOTER //
// ./src/scripts/constants/CampaignConstants.js